module.exports = __webpack_public_path__ + "img/real-estate-agent.fb580d04.svg";